import { render, staticRenderFns } from "./discard.vue?vue&type=template&id=2585b9ea&scoped=true&"
import script from "./discard.vue?vue&type=script&lang=js&"
export * from "./discard.vue?vue&type=script&lang=js&"
import style0 from "./discard.vue?vue&type=style&index=0&id=2585b9ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585b9ea",
  null
  
)

export default component.exports